<template>
  <footer>
    Footer default
  </footer>
</template>
<script>
export default {
  name: "FooterDefault"
};
</script>
<style scoped lang="scss">
@import "@/assets/style/css/generic-variables.scss";
</style>
